import i from"./function-name.js";import n from"./fails.js";import o from"./whitespaces.js";var e=i.PROPER,f=n,a=o,t="\u200B\x85\u180E",m=function(r){return f(function(){return!!a[r]()||t[r]()!==t||e&&a[r].name!==r})};export{m as default};
